import type { GridApiPremium, GridDataSource } from "@mui/x-data-grid-premium";
import type { RefObject } from "react";
import { useCallback, useState } from "react";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import DataGrid from "@entrilia/shared/components/grid/DataGrid";
import { GRID_DEFAULT_PAGE_SIZE } from "@entrilia/shared/components/grid/gridHelper";
import { logError } from "@entrilia/shared/logging";
import type { DataCollectionSubmissionInfo } from "../../../../api/types/dataCollectionTypes";
import storage from "../../../../storage/storage";
import { columnDefinitions } from "./dataSubmissionsGridDataProvider";

interface Props {
  apiRef: RefObject<GridApiPremium | null>;
  dataSource: GridDataSource;
  filterId: string;
  lazyLoading?: boolean;
}

const DataSubmissionsGrid = ({ apiRef, dataSource, filterId, lazyLoading }: Props) => {
  const [dataSourceError, setDataSourceError] = useState<Error>();

  const handleDataSourceError = useCallback(
    (error: Error) => {
      logError(error, "[DataSubmissionsGrid]");
      setDataSourceError(error);
      storage.clearFilterState(filterId);
    },
    [filterId]
  );

  if (dataSourceError) {
    return <DataLoadingFailed title="Loading data submissions failed" />;
  }

  return (
    <DataGrid<DataCollectionSubmissionInfo>
      apiRef={apiRef}
      columns={columnDefinitions}
      lazyLoading={lazyLoading}
      dataSource={dataSource}
      paginationModel={{ page: 0, pageSize: GRID_DEFAULT_PAGE_SIZE }}
      onDataSourceError={handleDataSourceError}
      noRowsText="No data submissions"
      disableColumnReorder
      disableColumnSorting
    />
  );
};

export default DataSubmissionsGrid;
